import React, { useState } from 'react';

function PartSVG() {

    const [inSVG, setInSVG] = useState();
    const [outSVG, setOutSVG] = useState();
    const [svgfilename, setSVGFileName] = useState();


    return (

        <div className="col-md-12 p-2">
            <div className="h-100 p-5 pb-4 text-white bg-dark rounded-3">
                <h2>SVG处理</h2>
                <p>&lt;Polygon/&gt; Transform to &lt;Line/&gt;</p>

                <input type="file" accept="image/svg+xml"
                    style={{ width: 200, marginTop: 10 }}
                    onChange={(e) => {
                        // console.log(e.target.files[0])
                        // console.log('url', URL.createObjectURL(e.target.files[0]))
                        let name = e.target.files[0].name;
                        setSVGFileName(name.substring(0, name.indexOf(".")))
                        setInSVG(URL.createObjectURL(e.target.files[0]))

                    }} />


                {inSVG ?

                    <embed id="embed" src={inSVG} width={1} height={1} type="image/svg+xml"
                        // <object aria-label=' ' data={inSVG} width={1} height={1} type="image/svg+xml"
                        onLoad={(e) => {
                            // console.log(e);
                            var docm = e.target.getSVGDocument();
                            // var docm = e.target.contentDocument;

                            var lines = new Set();

                            var polys = docm.querySelectorAll('polygon,polyline');
                            [].forEach.call(polys, convertPolyToPath);

                            console.log(lines.size)

                            //全局style
                            var svgel = docm.querySelector('svg')
                            svgel.setAttribute('style', "stroke:rgb(0,0,0);stroke-width:1");
                            var svgString = new XMLSerializer().serializeToString(svgel);

                            //格式化 xml string
                            var formatted = '', indent = '', tab = '    ';
                            svgString.split(/>\s*</).forEach(function (node) {
                                if (node.match(/^\/\w/)) indent = indent.substring(tab.length);
                                formatted += indent + '<' + node + '>\r\n';
                                if (node.match(/^<?\w[^>]*[^\/]$/)) indent += tab;
                            });
                            svgString = formatted.substring(1, formatted.length - 3);
                            // console.log(svgString);

                            var blob = new Blob([svgString], { type: "image/svg+xml;charset=utf-8" });
                            var durl = URL.createObjectURL(blob);
                            // console.log(durl)
                            setOutSVG(durl)


                            function convertPolyToPath(poly) {
                                var svgNS = poly.ownerSVGElement.namespaceURI;
                                var pathdata = poly.getAttribute('points');
                                var l = pathdata.split(" ");
                                // console.log(l.length);
                                for (let index = 0; index < l.length; index++) {
                                    if (l[index]) {
                                        var p0 = l[index];
                                        var p1 = l[0];
                                        if (l[index + 1]) {
                                            p1 = l[index + 1];
                                        }
                                        var points1 = p0.split(',');
                                        var x1 = points1.shift(), y1 = points1.shift();
                                        var points2 = p1.split(',');
                                        var x2 = points2.shift(), y2 = points2.shift();
                                        // <line xmlns="http://www.w3.org/2000/svg" x1="628.736" y1="757.859" x2="575.270" y2="642.086" style="stroke:rgb(255,0,0);stroke-width:2"/>
                                        var line = document.createElementNS(svgNS, 'line');

                                        //从左到右画，方便后面去重
                                        if (x1 <= x2) {
                                            line.setAttribute('x1', x1);
                                            line.setAttribute('y1', y1);
                                            line.setAttribute('x2', x2);
                                            line.setAttribute('y2', y2);
                                        } else {
                                            line.setAttribute('x1', x2);
                                            line.setAttribute('y1', y2);
                                            line.setAttribute('x2', x1);
                                            line.setAttribute('y2', y1);
                                        }

                                        // 去重
                                        // poly.parentNode.appendChild(line);
                                        var o = document.createElement("div");
                                        o.appendChild(line);
                                        if (!lines.has(o.innerHTML)) {
                                            lines.add(o.innerHTML)
                                            poly.parentNode.appendChild(line);
                                        }
                                    }
                                }
                                poly.parentNode.removeChild(poly);
                            }
                        }} />
                    : ''
                }

                {outSVG ?
                    <a className="btn btn-outline-light mt-4" type="button"
                        style={{
                            width: 100,
                            display: 'block'
                        }}
                        href={outSVG}
                        download={svgfilename}
                    >
                        下载结果
                    </a>
                    :
                    ''
                }

            </div>
        </div>
    )
}

export default PartSVG;